var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.addClass + ' filter-option select-item-font d-inline-flex align-items-center justify-content-center' + (_vm.active ? ' active' : '') + (_vm.icon ? ' with-icon' : ''),style:(_vm.icon ? _vm.iconStyle : ''),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }